<div class="row page-header">
    <div class="col-12">
        <h1>Vendors <small>Specify what types of services the vendors from Vista provide</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                        (pasting)="pasting(mainGrid, $event)"
                        (pasted)="pasted(mainGrid, $event)"
                        [itemsSource]="grid.view"
                        [itemFormatter]="itemFormatter"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'3*'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Is Rental'" [binding]="'isRental'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Is Aggregate'" [binding]="'isAggregate'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Is Concrete'" [binding]="'isConcrete'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Is Pump Truck'" [binding]="'isPumpTruck'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Is Tester'" [binding]="'isConcreteTester'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Is Saw Cutter'" [binding]="'isSawCutter'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Is Crane'" [binding]="'isCrane'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Is Lessor'" [binding]="'isLessor'" [width]="'*'"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
